<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Demanda de Exames e Terapias"
description="Cadastre ou edite as demandas de exames e terapias">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">
  <form [formGroup]="formResourceDemand" (ngSubmit)="addResourceDemand()" data-cy="resource-demand-form">

    <!-- Seção: Exames -->
    <section class="mb-lg">
      <div class="card">
        <div class="card-header">
          <div class="section-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
              <path d="M208,80H176V48a16,16,0,0,0-16-16H96A16,16,0,0,0,80,48V80H48A16,16,0,0,0,32,96v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,48h64V80H96Zm72,104H152v16a8,8,0,0,1-16,0V152H120a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" opacity="0.2"/><path d="M208,72H180V48a20,20,0,0,0-20-20H96A20,20,0,0,0,76,48V72H48A24,24,0,0,0,24,96V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V96A24,24,0,0,0,208,72ZM92,48a4,4,0,0,1,4-4h64a4,4,0,0,1,4,4V72H92ZM216,192a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8Zm-56-40a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"/>
            </svg>
            <h3 class="card-title">Exames</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="checkbox-grid" *ngIf="formResourceDemand.get('resource')" formArrayName="resource">
            <ng-container *ngFor="let resource of examResources">
              <mat-checkbox [formControlName]="getResourceIndex(resource.key)">
                {{ resource.label }}
              </mat-checkbox>
            </ng-container>
          </div>
        </div>
      </div>
    </section>

    <!-- Seção: Terapias -->
    <section class="mb-lg">
      <div class="card">
        <div class="card-header">
          <div class="section-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
              <path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z" opacity="0.2"/><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"/>
            </svg>
            <h3 class="card-title">Terapias</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="checkbox-grid" *ngIf="formResourceDemand.get('resource')" formArrayName="resource">
            <ng-container *ngFor="let resource of therapyResources">
              <mat-checkbox [formControlName]="getResourceIndex(resource.key)">
                {{ resource.label }}
              </mat-checkbox>
            </ng-container>
          </div>
        </div>
      </div>
    </section>

    <!-- Seção: Localização e Publicação -->
    <section class="mb-lg">
      <div class="card">
        <div class="card-header">
          <div class="section-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
              <path d="M128,16a96,96,0,1,0,96,96A96,96,0,0,0,128,16Zm0,144a48,48,0,1,1,48-48A48,48,0,0,1,128,160Z" opacity="0.2"/><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-144a56,56,0,1,0,56,56A56.06,56.06,0,0,0,128,72Zm0,96a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"/>
            </svg>
            <h3 class="card-title">Localização e Publicação</h3>
          </div>
        </div>
        <div class="card-body">

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Endereço de Atendimento</mat-label>
            <mat-select formControlName="address" data-cy="address-select">
              <mat-option *ngFor="let address of addresses" [value]="address">
                {{ address.street }}, {{ address.number }} - {{ address.district }},
                {{ address.city }}/{{ address.state }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="date-fields">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Data de Início da Publicação</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="publicationDate"
                [matDatepickerFilter]="dateFilter" data-cy="publication-date-input" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Data de Fim da Publicação</mat-label>
              <input matInput [matDatepicker]="picker2" formControlName="expirationPublicationDate"
                [matDatepickerFilter]="dateLimitFilter" data-cy="expiration-date-input" />
              <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Descrição</mat-label>
            <textarea matInput formControlName="description" rows="4" data-cy="description-textarea"
              placeholder="Descreva os detalhes da sua demanda de exames e terapias..."></textarea>
          </mat-form-field>

        </div>
      </div>
    </section>

    <!-- Seção: Disponibilidade -->
    <section class="mb-lg">
      <div class="card">
        <div class="card-header">
          <div class="section-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="var(--color-primary)" viewBox="0 0 256 256" class="section-icon">
              <path d="M216,48H40a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM176,160H128a8,8,0,0,1,0-16h48a8,8,0,0,1,0-16Zm0-32H128a8,8,0,0,1,0-16h48a8,8,0,0,1,0-16Z" opacity="0.2"/><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24ZM96,112a8,8,0,1,1-8-8A8,8,0,0,1,96,112Zm0,32a8,8,0,1,1-8-8A8,8,0,0,1,96,144Zm32-32a8,8,0,1,1-8-8A8,8,0,0,1,128,112Zm0,32a8,8,0,1,1-8-8A8,8,0,0,1,128,144Zm32-32a8,8,0,1,1-8-8A8,8,0,0,1,160,112Zm0,32a8,8,0,1,1-8-8A8,8,0,0,1,160,144Zm-64,32a8,8,0,1,1-8-8A8,8,0,0,1,96,176Zm32,0a8,8,0,1,1-8-8A8,8,0,0,1,128,176Z"/>
            </svg>
            <h3 class="card-title">Disponibilidade</h3>
          </div>
        </div>
        <div class="card-body">
          <app-availability
            [availability]="availability"
            (availabilityChange)="onAvailabilityChange($event)"
            [editable]="true">
          </app-availability>
        </div>
      </div>
    </section>

    <!-- Botões de Ação -->
    <div class="footerButtons">
      <button mat-button routerLink="../../" type="button" data-cy="cancel-button">
        <mat-icon>undo</mat-icon>
        Cancelar
      </button>
      <button mat-raised-button color="primary" type="submit" [disabled]="formResourceDemand.invalid"
        data-cy="submit-button">
        <mat-icon>{{ id ? 'save' : 'add_circle' }}</mat-icon>
        {{ id ? "Salvar Alterações" : "Criar Demanda" }}
      </button>
    </div>

  </form>
</div>
}